import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef, useState } from "react";
// @mui
import { Box } from "@mui/material";
import Fabrizo from "src/images/summus_logo_trasparente.png";

// ----------------------------------------------------------------------
const Page = forwardRef(({ children, title = "", meta, ...other }, ref) => {
  const [imageLoaded, setImageLoaded] = useState(true);
  const favicon = localStorage.getItem("favicon");
  return (
    <>
      {/* <Helmet>
        <title>{`${title} | Cloud-MLM`}</title>
        <link rel="apple-touch-icon" sizes="180x180" href={favicon} />
        <link rel="icon" type="image/png" sizes="32x32" href={favicon} />
        <link rel="icon" type="image/png" sizes="16x16" href={favicon} />
        <link rel="shortcut icon" href={favicon} type="image/png/ico" />
        {meta}
      </Helmet> */}

      <Box ref={ref} {...other}>
        {children}
      </Box>
    </>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
